import React, { ReactNode } from 'react'
import {
  DesignVersionProvider,
  DialogUnwrapped,
  ParticleDesignVersions,
} from '@klarna/bubble-ui'
import config from '../../config'
import styles from './Layout.css'

type LayoutProps = {
  onClose: () => void
  theme: 'default' | 'dark' | 'custon'
  children: ReactNode
  bespokeId?: string
  footerButtons: any
  focusTrapActive?: boolean
};

export default function Layout(props: LayoutProps) {
  const {
    theme,
    onClose,
    footerButtons,
    bespokeId,
    children,
    focusTrapActive = false
  } = props

  const designVersion = theme === 'dark'
    ? ParticleDesignVersions.WAFFLE_DARK
    : ParticleDesignVersions.WAFFLE_LIGHT

  const backgroundColorKey = theme === 'dark' ? 'darkBackgroundTheme' : 'backgroundTheme'
  const includeLogoInLayout = !['payment-calculator-interstitial-revamped'].includes(bespokeId)

  const dialogId = `${bespokeId || 'default'}-${theme || 'default'}`
  return (
    <DesignVersionProvider value={designVersion}>
      <DialogUnwrapped
        focusTrapActive={focusTrapActive}
        onClose={onClose}
        captureEscapeKey={true}
        klarnaLogoAccessibilityLabel="Klarna logo"
        rightIconAriaLabel="Close"
        onBackgroundClick={onClose}
        klarnaLogo={includeLogoInLayout}
        footer={footerButtons}
        backgroundColorToken={
          config[backgroundColorKey][bespokeId || 'default']
        }
        id={dialogId}
        focusTrapOptions={{
          // the focus should fallback to the parent div if no focusable contents are found
          fallbackFocus: `#${dialogId}`
        }}
        UNSAFE_containerProps={{
          // negative tab index so the div can be programatically focused on fallbackFocus
          tabIndex: -1
        }}
      >
        <style>{styles}</style>
        <div id="interstitial-wrapper">
          <div>
            {children}
          </div>
        </div>
      </DialogUnwrapped>
    </DesignVersionProvider>
  )
}
